import {
  ChangeDetectionStrategy,
  Component,
  input,
  ElementRef,
  ViewChild,
  inject,
  afterRenderEffect,
  effect,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SessionService } from '@core/services/session.service';
import { SocketService } from '@core/services/socket.service';
import { SvgIconComponent } from 'angular-svg-icon';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-trade-url',
  imports: [SvgIconComponent, ReactiveFormsModule],
  templateUrl: './user-trade-url.component.html',
  styleUrl: './user-trade-url.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UserTradeUrlComponent {
  sessionService = inject(SessionService);
  toastrService = inject(ToastrService);
  socketService = inject(SocketService);

  onMountFocusTradeURL = input<boolean>(false);

  constructor() {
    effect(() => {
      this.tradeURLForm
        .get('tradeURL')
        ?.setValue(this.sessionService.stats().trade_url);
    });

    afterRenderEffect(() => {
      if (this.onMountFocusTradeURL()) {
        this.tradeURLInput.nativeElement.focus();
      }
    });
  }

  @ViewChild('tradeURLInput') tradeURLInput!: ElementRef<HTMLInputElement>;

  tradeURLForm = new FormGroup({
    tradeURL: new FormControl<string>('', [
      Validators.required,
      Validators.pattern(
        '^https://steamcommunity.com/tradeoffer/new/\\?partner=[0-9]+&token=[a-zA-Z0-9_-]+$'
      ),
    ]),
  });

  async tradeURLSubmit() {
    if (this.tradeURLForm.invalid) {
      this.toastrService.error(
        'Invalid trade URL format. Please use the correct format.'
      );
      return;
    }

    const tradeURL = this.tradeURLForm.get('tradeURL')?.value;

    try {
      const tradeUrl = await this.socketService.emit('trade_save', {
        trade: tradeURL,
      });

      if (tradeUrl) {
        this.sessionService.stats.update((prev) => ({
          ...prev,
          trade_url: tradeUrl,
        }));
        this.toastrService.success('Trade URL updated successfully.');
      }
    } catch (error) {
      this.toastrService.error('Failed to update trade URL. Please try again.');
    }
  }
}
